import {
  ReviewsSection_ReviewSummary_ActionStatement_ActionStatementType as ActionStatementType,
  ReviewsSection_ReviewSummary_ActionStatement,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {GenericIconName, Icon, IconName, Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const ReviewsActionStatement: FC<{
  actionStatements: ReviewsSection_ReviewSummary_ActionStatement[];
}> = ({actionStatements}) => {
  return (
    <Wrapper>
      {actionStatements.map((action, index) => (
        <ActionWrapper
          key={`action-statement-${index}`}
          data-testid={`actionStatement-${index}`}
          basis={100 / actionStatements.length}
        >
          {action.type !== 0 && (
            <Icon
              size={'S'}
              asset={GenericIconName[actionIcons[action.type]] as IconName}
              data-testid={`actionStatement-${
                action.type === 1 ? 'fit' : 'quality'
              }`}
            />
          )}
          <ActionTextContainer isIconRendered={action.type !== 0}>
            <Text
              weight="light"
              data-testid={`actionStatementHeadline-${index}`}
            >
              {action.headline}
            </Text>
          </ActionTextContainer>
        </ActionWrapper>
      ))}
    </Wrapper>
  );
};

const actionIcons: {
  [k in ActionStatementType]: keyof typeof GenericIconName;
} = {
  // Value 0 is omitted and will not be rendered
  '0': GenericIconName.Close,
  '1': GenericIconName.Ruler,
  '2': GenericIconName.UspProofOfQuality,
};

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 0.8rem;
  margin-top: 1rem;
`;

const ActionWrapper = styled.div<{basis: number}>`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 0.6rem;
  flex-basis: ${({basis}) => `${basis}%`};
`;

const ActionTextContainer = styled.div<{isIconRendered: boolean}>`
  display: flex;
  flex-direction: column;
  margin-left: ${({isIconRendered}) => (isIconRendered ? '5px' : '30px')};
`;
